<template>
  <slot></slot>
</template>

<script setup>
import { onMounted, provide, ref, watch } from "vue";
import pako from "pako";

const props = defineProps({
  url: {
    type: String,
    required: false,
    default: null,
  },
  inlineChartData: {
    type: Array,
    required: false,
    default: null,
  },
  chartDataIsAggregate: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const loading = ref(false);
const chartData = ref([]);
const chartDataIsAggregate = ref(false);

provide("livingWageGapCalculationChartDataLoading", loading);
provide("livingWageGapCalculationChartData", chartData);
provide("livingWageGapCalculationChartDataIsAggregate", chartDataIsAggregate);

async function loadCalculationChartData() {
  if (Array.isArray(props.inlineChartData)) {
    chartData.value = props.inlineChartData;
    chartDataIsAggregate.value = props.chartDataIsAggregate;
    loading.value = false;
    return;
  }

  if (!props.url) {
    loading.value = false;
    chartData.value = [];
    chartDataIsAggregate.value = false;
    return;
  }

  loading.value = true;
  chartDataIsAggregate.value = false;

  const response = await fetch(props.url);
  if (!response.ok) {
    chartData.value = [];
    loading.value = false;
    chartDataIsAggregate.value = false;
    return;
  }

  const buffer = await response.arrayBuffer();
  const jsonText = pako.ungzip(new Uint8Array(buffer), { to: "string" });
  const parsedChartData = JSON.parse(jsonText);

  chartData.value = Array.isArray(parsedChartData) ? parsedChartData : [];
  loading.value = false;
}

function handleLoadError(error) {
  loading.value = false;
  chartData.value = [];
  chartDataIsAggregate.value = false;

  // Keep the page functional even if payload loading fails.
  console.error(
    "[LivingWageGapCalculationChartDataLoader] Failed to load data",
    error,
  );
}

onMounted(() => {
  loadCalculationChartData().catch(handleLoadError);
});

watch(
  () => [props.url, props.inlineChartData, props.chartDataIsAggregate],
  () => {
    loadCalculationChartData().catch(handleLoadError);
  },
);
</script>
